import _ from 'lodash';
import { createSelector } from 'reselect';
import * as fromState from '../../../state/reducers';
import { ENTITY_TYPE, ENTITY_PROPERTY, ENTITY_FORM_TYPE } from '../../constants';

export default createSelector(
  [
    state => fromState.getFormValue(state, ENTITY_TYPE.ACTION_MAPPING, ENTITY_FORM_TYPE.ADD_OR_EDIT, 'connector'),
    state => fromState.getAll(state, ENTITY_TYPE.ACTION_CONNECTOR)
  ],
  (connector, allActionConnectors) => _.get(allActionConnectors[connector], ENTITY_PROPERTY.ACTION_CONNECTOR.TYPE)
);